import { render, staticRenderFns } from "./inventory-form.vue?vue&type=template&id=49a984b4&scoped=true"
import script from "./inventory-form.vue?vue&type=script&lang=ts"
export * from "./inventory-form.vue?vue&type=script&lang=ts"
import style0 from "./inventory-form.vue?vue&type=style&index=0&id=49a984b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a984b4",
  null
  
)

export default component.exports